import BackboneForm from "@grabyo/backbone-forms";
import _ from "underscore";
import "@grabyo/backbone-forms";

import UploaderView from "pages/common/components/uploader/uploader.backbone";

const UploadEditor = BackboneForm.editors.Base.extend({
    initialize: function (options) {
        // Call parent constructor
        BackboneForm.editors.Base.prototype.initialize.call(this, options);

        this.schema.options = this.schema.options || {};

        this.uploader = new UploaderView(this.schema.options);

        this.bindEvents();
    },

    bindEvents: function () {
        this.listenTo(
            this.uploader.collection,
            `add change:status remove`,
            this.updateValue
        );
        this.listenTo(
            this.uploader.collection,
            `upload:count`,
            this.triggerUploadCount
        );
        this.listenTo(
            this.uploader.collection,
            `change:status add remove reset`,
            this.triggerInvalidCount
        );
    },

    render: function () {
        this.$el.html(this.uploader.render().el);
        if (this.value) {
            this.setValue(this.value);
        }
        return this;
    },

    // This is only used to set preview images
    setValue: function (file) {
        this.uploader.collection.add({
            filename: file.substr(file.lastIndexOf(`/`) + 1),
            dataUrl: file,
            mimetype: `image/jpeg`,
            progress: 100,
            srcUrl: file,
            status: `valid`,
            url: file,
            ignore: true
        });
        this.updateValue();
    },

    getValue: function () {
        return this.value;
    },

    focus: function () {
        // nothing to do here
    },

    blur: function () {
        // nothing to do here
    },

    updateValue: function () {
        var files = this.uploader.collection.getFiles();
        var nonIgnoredFiles = _.pluck(
            files.filter(function (file) {
                return file.ignore !== true;
            }),
            `s3Filename`
        );

        if (files.length === 0) {
            this.value = null;
        } else if (this.schema.options.multiple === true) {
            this.value = nonIgnoredFiles;
        } else {
            this.value = nonIgnoredFiles[0];
        }

        if (
            (this.schema.options.compact === true ||
                this.schema.options.preview === true) &&
            this.schema.displayErrors !== false
        ) {
            var allFilesValid = this.uploader.collection.every(function (file) {
                return file.get(`status`) === `valid`;
            });

            if (allFilesValid) {
                this.$(`.js-live-validation-error`).remove();
            } else {
                var invalidFile = this.uploader.collection.findWhere({
                    status: `invalid`
                });
                if (!_.isUndefined(invalidFile)) {
                    this.$el.append(
                        this.form.errorTemplate({
                            message: invalidFile.get(`errorMessage`)
                        })
                    );
                }
            }
        }
    },

    triggerUploadCount: function (uploadCount) {
        this.trigger(`upload:count`, uploadCount);
    },

    triggerInvalidCount: function () {
        var hasInvalidFile = this.uploader.collection.some(function (file) {
            return file.get(`status`) === `invalid`;
        });

        if (hasInvalidFile) {
            var errorMessage = this.uploader.collection
                .findWhere({
                    status: `invalid`
                })
                .get(`errorMessage`);
            this.trigger(`upload:invalid`, errorMessage);
        }
    }
});

export default UploadEditor;

export const BackwardsCompatibleUploaderEditor = UploadEditor.extend({
    initialize: function (options) {
        BackboneForm.editors.Base.prototype.initialize.call(this, options);

        this.schema.options = this.schema.options || {};

        this.uploader = new UploaderView(this.schema.options);

        this.bindEvents();
    }
});
